import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { close } from '../../../modules/modal/actions';
import { HOME } from '../../../routes/paths';
import MobileNumberChanged from './MobileNumberChanged';

const mapDispatchToProps = {
  returnToHome: push.bind(push, HOME),
  close
};

export default connect(null, mapDispatchToProps)(MobileNumberChanged);
